import React from 'react';
import { Check } from 'iconoir-react';
import { PublicFooter } from '../components/PublicFooter';
import { getPlanPricing, getPlanDisplayFeatures, getPlanTagline } from '../utils/planPricing';
import { usePricingData } from './pricing/usePricingData';
import { PricingHeader } from './pricing/PricingHeader';
import { PricingComparisonTable } from './pricing/PricingComparisonTable';
import '../styles/pricing.css';

const MAX_MINI_CARD_FEATURES = 3;

export const PricingPage: React.FC = () => {
  const { plans, loading, error, yearlySavings, handleChoosePlan, ctaLabel } = usePricingData();

  return (
    <div className="landing-page">
      <PricingHeader />

      <section className="pricing-hero">
        <div className="landing-container">
          <h1>Des tarifs simples, une comparaison précise</h1>
          <p>Trois offres, un coup d'œil sur les prix, puis tous les détails juste en dessous.</p>
        </div>
      </section>

      <section className="pricing-section pricing-mini-section">
        <div className="landing-container">
          {loading && <div className="pricing-loading">Chargement des tarifs...</div>}
          {!loading && error && <div className="pricing-error">{error}</div>}

          {!loading && !error && (
            <div className="pricing-mini-grid">
              {plans.map((plan) => {
                const pricing = getPlanPricing(plan);
                const topFeatures = getPlanDisplayFeatures(plan).slice(0, MAX_MINI_CARD_FEATURES);
                const isYearly = pricing.billingPeriod === 'yearly' && !plan.has_ads;

                return (
                  <div key={plan.id} className={`pricing-mini-card ${isYearly ? 'pricing-mini-card-highlight' : ''}`}>
                    {isYearly && yearlySavings && (
                      <span className="pricing-mini-save-badge">Économisez {yearlySavings.percent}%</span>
                    )}
                    <h3>{plan.display_name}</h3>
                    <div className="pricing-mini-price">
                      <span className="pricing-mini-amount">{pricing.amount.toFixed(2)}€</span>
                      {pricing.suffix && <span className="pricing-mini-period">{pricing.suffix}</span>}
                    </div>
                    <p className="pricing-mini-tagline">{getPlanTagline(plan)}</p>
                    <ul className="pricing-mini-features">
                      {topFeatures.map((feature, index) => (
                        <li key={index}>
                          <Check width={13} height={13} strokeWidth={2.5} /> {feature}
                        </li>
                      ))}
                    </ul>
                    <button type="button" className="pricing-mini-cta" onClick={() => handleChoosePlan(plan)}>
                      {ctaLabel(plan)}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {!loading && !error && (
        <section className="pricing-section pricing-compare-section">
          <div className="landing-container">
            <h2 className="pricing-section-title">Comparer les offres</h2>
            <PricingComparisonTable plans={plans} ctaLabel={ctaLabel} onChoosePlan={handleChoosePlan} />
          </div>
        </section>
      )}

      <PublicFooter />
    </div>
  );
};
